import { Typography, Flex } from "antd";
import { CustomButton } from "ui/Buttons/CustomButton/CustomButton";
import { convertFromSecondsToTime } from "utils";
import styles from "./OtpTimeLeft/otpTimeLeft.module.css";

interface OtpTimeLeftWithCProps {
  onResend: () => void;
  loading?: boolean;
  className?: string;
  buttonText?: string;
  countdownText?: string;
  timeLeft?: number;
}

export const OtpTimeLeftWithContext: React.FC<OtpTimeLeftWithCProps> = ({
  onResend,
  loading = false,
  className = "",
  buttonText = "Получить новый код",
  countdownText = "Получить новый код через",
  timeLeft = 0,
}) => {
  return (
    <Flex vertical align="center" className={`${styles.container} ${className}`}>
      {timeLeft > 0 ? (
        <Typography.Text strong className={styles.countdownText}>
          {countdownText} {convertFromSecondsToTime(timeLeft)}
        </Typography.Text>
      ) : (
        <CustomButton type="default" size="xlarge" onClick={onResend} fullWidth disabled={loading}>
          {buttonText}
        </CustomButton>
      )}
    </Flex>
  );
};
